<script>
import ProInput from '$common/ProInput'
import ProSelect from '$common/ProSelect'
import courses from '@/global/js/courses'
import states from '@/global/js/states'
import countries from '@/global/js/countries'
import ethnicities from '@/global/js/ethnicities'
import genders from '@/global/js/genders'
export default {
  name: 'CreateStudent',
  components: {
    'pro-input': ProInput,
    'pro-select': ProSelect
  },
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      student: {
        name: '',
        birthday: '',
        ethnicity: null,
        gender: null,
        gender_self_description: '',
        outside_of_us: false,
        city: '',
        state: '',
        country: '',
        classes: [],
        previous_coding_experience: '',
        want_to_learn_next: '',
        guardian_id: '',
      },
      formOptions: {
        name: {
          title: 'First and Last Name',
          errorIf: (val) => val ? '' : 'Enter name',
        },
        birthday: {
          errorIf: val => '',
          // errorIf: val => val ? '' : 'Enter birthday',
        },
        ethnicity: {
          title: 'Ethnicity',
          type: 'select',
          errorIf: val => '',
          // errorIf: val => val ? '' : 'Enter ethnicity',
        },
        gender: {
          title: 'Gender',
          type: 'select',
          errorIf: val => '',
          // errorIf: val => val ? '' : 'Enter gender', 
        },
        gender_self_description: {
          title: "Gender self description",
          errorIf: val => '',
          // errorIf: (val, student) => (student.gender === 'Prefer to self-describe') && !val ? 'Input self-described gender' : '',
        },
        outside_of_us: {
          title: 'Outside of US',
          prompt: 'This participant is not in the United States',
          type: 'checkbox',
          errorIf: val => '',
        },
        city: {
          title: 'City',
          errorIf: val => '',
          // errorIf: val => val ? '' : 'Enter city',
        },
        state: {
          title: 'State',
          type: 'select',
          errorIf: val => '',
          // errorIf: (val, student) => !student.outside_of_us && !val ? 'Enter state' : '',
        },
        country: {
          title: 'Country',
          type: 'select',
          errorIf: val => '',
          // errorIf: (val, student) => student.outside_of_us && !val ? 'Enter country' : '',
        },
        classes: {
          title: "Classes",
          errorIf: val => val && val.length ? '' : 'Choose at least one class',
        },
        previous_coding_experience: {
          errorIf: val => '',
          title: 'Previous coding experience (ex. HTML, CSS, and a little bit of Python)',
        },
        want_to_learn_next: {
          errorIf: val => '',
          title: 'What you want to learn next (ex. I’m programming a project in Python for school and need help)',
        },
        guardian_id: {
          title: 'Guardian',
          type: 'select',
          errorIf: val => val || this.isAdultStudent ? '' : 'Select Guardian'
        },
      },
      ethnicities,
      genders,
      states,
      countries,
      userTypes: [
        'ONLINE_STUDENT',
        'ADULT_STUDENT'
      ],
      classes: [],
      guardians: [],
      editing: false,
      saving: false,
      adminDeclaredUserType: '',
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isAdmin () {
      return this.user.user_type.includes('ADMIN')
    },
    isAdultStudent () {
      return (this.options.info && this.options.info.user_type.includes('ADULT_STUDENT')) || this.adminDeclaredUserType === 'ADULT_STUDENT'
    },
    skipFields () {
      let skipArray = []
      if (this.isAdultStudent)
        skipArray.push(...['previous_coding_experience', 'want_to_learn_next'])
      if (this.student.gender !== 'Prefer to self-describe')
        skipArray.push('gender_self_describe')
      return skipArray
    }
  },
  methods: {
    async onSubmit(){
      const errors = await this.getErrors()
      if (errors.length) return errors.forEach(err => this.$toast({copy: err, class: 'alert'}))

      this.saving = true
      const studentId = this.editing ? this.options.info.id : this.$firestore.collection('users').doc().id
      const studentRef = this.$firestore.collection('users').doc(studentId)
      let dataToSave = this.student
      let userType = this.isAdultStudent ? 'ADULT_STUDENT' : 'ONLINE_STUDENT'
      if (this.isAdultStudent) {
        delete dataToSave.guardian_id
      }

      //set studentData to the appropriate firebase call
      let studentData
      if (this.editing) {
        studentData = studentRef.update({
          ...this.student
        })
      } else {
        studentData = studentRef.set({
          user_type: [userType],
          id: studentId,
          created: Date.now(),
          paperwork_complete: false,
          paperwork: {},
          ...this.student
        })
      }

      try {
        await Promise.resolve(studentData)
      } catch (e) {
        console.error(e)
        this.$toast('Student was not saved. Please try again.')
        this.saving = false
        return
      }

      this.saving = false
      this.$toast(`Student ${this.editing ? 'updated' : 'created'}.`)
      if (!this.isAdmin) {
        const user = (await this.$firestore.doc(`users/${this.user.id}`).get()).data()
        this.$store.commit('update', {user})
      }
      this.$modals.hide('create-student')

      const successFunc = this.options.onSuccess
      if (successFunc) successFunc()
    },
    getErrors () {
      return new Promise(async (resolve, reject) => {
        const checkErrorIfs = () => Object.keys(this.student)
          .map(key => this.formOptions[key].errorIf(this.student[key]))
          .filter(Boolean)

        const studentErrors = checkErrorIfs()

        resolve([
          ...studentErrors,
        ])
      })
    },
    getBirthdayInputOptions () {
      return {
        title: 'Student\'s birthday',
        type: 'date',
        errorIf: val => val ? '' : 'Enter birthday',
      }
    },
    createOptions (key) {
      let list
      if (key == 'ethnicity') list = this.ethnicities
      else if (key == 'gender') list = this.genders
      else if (key == 'state') list = this.states
      else if (key == 'country') list = this.countries
      else if (key == 'user_types') list = this.userTypes
      else if (key == 'guardian_id'){
        return this.guardians.map(guardian => ({value: guardian.id, name: guardian.name}))
      } 
      else console.log('key',key)
      return list.map(str => ({value: str, name: str}))
    },
    addRemoveClass (classId) {
      console.log(classId)
      const hasClass = this.student.classes.includes(classId)
      console.log('hasClass',hasClass)
      this.student.classes[hasClass ? 'remove' : 'push'](classId)
    },
    async getGuardians () {
      this.guardians = (await this.$firestore.collection('users').where('user_type', 'array-contains', 'GUARDIAN').get()).docs.map(doc => doc.data())
      //sort alphabetically for a nice drop down
      this.guardians = this.guardians.sort((a, b) => (a.name > b.name) ? 1 : -1)
    }
  },
  async mounted () {
    if (this.isAdmin) {
      await this.getGuardians()
      if (this.isAdultStudent) this.adminDeclaredUserType = 'ADULT_STUDENT'
      else this.adminDeclaredUserType = 'ONLINE_STUDENT'
    }
    if (this.options.info) {
      console.log(this.isAdultStudent)
      this.editing = true
      Object.keys(this.student).forEach((key) => {
        // something is screwy with assigning the 'classes' key so we do it manually
        if (key !== 'classes') this.student[key] = this.options.info[key]
        else this.options.info.classes.forEach(classId => this.student.classes.push(classId))
      })
    }
    const allClasses = await this.$classes().classList()
    Object.keys(allClasses).forEach(key => {
      // console.log(allClasses[key])
      if (!allClasses[key].done) this.classes.push({
        course_id_full: key,
        ...allClasses[key]
      })
    })
  },
}
</script>

<template lang="pug">
  #note-main.modal-main
    .note-container.modal-container
      .title {{options.info ? 'Edit' : 'Create'}} Student
      .content
        .notes-section
          .form-holder
            .pro-form
              .row-title Student Information
              .form-row(
                v-for='(options, key, idx) in formOptions'
                v-if='key !== "classes" && (key !== "guardian_id" || (isAdmin && !isAdultStudent))  && !skipFields.includes(key)'
              )
                pro-input(
                  v-if='key=="birthday"'
                  :options='getBirthdayInputOptions()'
                  v-model='student[key]'
                )
                pro-select(
                  v-else-if='options.type=="select"'
                  :options='createOptions(key)'
                  :title='options.title'
                  v-model='student[key]'
                )
                pro-input(
                  v-else
                  :options='options'
                  v-model='student[key]'
                )
              template(
                v-if='isAdmin'
              )
                .form-row
                  pro-select(
                    :options='createOptions("user_types")'
                    v-model='adminDeclaredUserType'
                  )
                .form-row
                  .title Select 1 or more classes:
                  .sub-title Note: As an admin, you may add students to courses that are full.
                  .course(
                    v-for='(aClass) in classes'
                    :options='{prompt: aClass.course_id_full.replace(/_/gi," "), type: "checkbox"}'
                    @click='addRemoveClass(aClass.course_id_full)'
                  ) 
                    i.material-icons {{student.classes.includes(aClass.course_id_full) ? 'check_circle': ''}}
                    span {{aClass.isFirestore ? aClass.course_id.replace(/_/gi," ") + " " + aClass.date_start.split('-')[0] + " " +  aClass.month : aClass.course_id_full.replace(/_/gi," ")}}

      .action
        .button.minor(
          @click='$modals.hide(`create-student`)'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) {{saving ? "Saving..." : "Save Student"}}
</template>

<style lang="sass" scoped>
.form-row
  .title
    font-size: 1.25rem
    font-weight: 600
  .sub-title
    font-size: 0.8rem
    margin-bottom: 1rem
  .course
    display: grid
    grid-template-columns: 2rem auto
    height: 2rem
    cursor: pointer
    span
      text-transform: capitalize
    i
      color: $orange
.row-title
  margin-bottom: 1rem
</style>